/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    var util = MoyaContainer.get('core.util');
    MoyaComponents.register('travel.booking', function (el) {
        var booking = new Booking(el);
        booking.run();
    });
    var Booking = /** @class */ (function () {
        function Booking(el) {
            this.el = el;
            this.canvasElm = document.querySelector(el.dataset.canvasElementSelector);
        }
        Booking.prototype.run = function () {
            this.bindButtons();
        };
        Booking.prototype.bindButtons = function () {
            var _this = this;
            util.delegate(this.el.querySelector('.book.new'), 'click', 'button', function () {
                _this.canvasElm.classList.toggle('open');
                document.body.classList.toggle('locked');
            });
            util.delegate(document.querySelector('button.canvas_close'), 'click', 'button', function () {
                _this.canvasElm.classList.add('closing');
                setTimeout(function () {
                    _this.canvasElm.classList.remove('closing');
                    document.body.classList.remove('locked');
                    _this.canvasElm.classList.remove('open');
                    var iframe = _this.canvasElm.querySelector('iframe');
                    iframe.src = iframe.src;
                }, 505);
            });
        };
        return Booking;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
